import { memo, useMemo } from 'react';

import { Image } from 'antd';
import cn from 'classnames';

import { THEME } from '@/shared/constants/theme';
import { useTheme } from '@/shared/lib/hooks';

import DarkLogoImage from '@/shared/assets/images/algotech-full-black.png';
import WhiteLogoImage from '@/shared/assets/images/algotech-full-white.png';

interface FullLogoProps {
    className?: string;
    isAuth?: boolean;
}

export const FullLogo = memo((props: FullLogoProps) => {
    const { className, isAuth = false } = props;

    const [theme] = useTheme();

    const imageSource = useMemo(
        () =>
            theme === THEME.light && !isAuth ? DarkLogoImage : WhiteLogoImage,
        [theme, isAuth],
    );

    return (
        <Image
            preview={false}
            rootClassName={cn(className)}
            src={imageSource}
        />
    );
});

FullLogo.displayName = 'FullLogo';
